/**
 * Where an organization turns its card wallet on, outside the cards page. Its own file so the cards module
 * can point here without importing the Settings page (which imports the cards explainer).
 *
 * Not `tarjetas`: that anchor is the old card-notifications section and redirects to
 * `/app/cards/notifications`.
 */
export const CARD_WALLET_SECTION_ID = "wallet-tarjetas";

export const CARD_WALLET_SETTINGS_PATH = `/app/settings?section=${CARD_WALLET_SECTION_ID}`;
